export function parseCookies(cookieStr: string) {
	cookieStr = cookieStr.trim();
	if (!cookieStr) return new Map();

	const cookies = new Map(
		cookieStr.split(';').map((cookie) => {
			const parts = cookie.split('=');
			const name = parts[0].trim();
			const value = decodeURIComponent(parts[1]);

			return [name, value];
		}),
	);

	return cookies;
}
